module.exports = __webpack_public_path__ + "static/img/hayneedle.10958627.jpg";